<template>
  <div>
    <div v-if="mainPage">
      <b-navbar
        toggleable="lg"
        v-if="scrollPosition > 50 || clicked === true"
        type="light"
        id="nav-home"
        fixed="top"
        :class="{ change_color: scrollPosition > 50 || clicked === true  }"
      >
        <!-- Left aligned Header -->
        <b-navbar-brand href="/" v-if="scrollPosition > 50 || clicked === true">
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>
        <b-navbar-brand href="/" v-else>
          <img id="ftcash-logo" :src="require(`@/assets/ftcash-white.png`)" alt="ftcash logo" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" @click="checkUncheck"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned Header -->
          <b-navbar-nav id="white-nav" class="ml-auto">
            <router-link class="my-auto nav-item nav-part text-decoration-none" to="/">Home</router-link>
            <router-link class="my-auto nav-item nav-part text-decoration-none" to="/about">About us</router-link>

            <b-nav-item-dropdown id="business-loan" class="my-auto nav-part" text="Products" right>
              <router-link to="/secured-business-loan" class="dropdown-item nav-drop-item">Secured</router-link>
              <router-link to="/" class="dropdown-item nav-drop-item">Unsecured</router-link>
              <router-link to="/pos" class="dropdown-item nav-drop-item">PoS</router-link>
            </b-nav-item-dropdown>
            <!--<router-link
              id="nav-features"
              class="my-auto nav-item nav-part text-decoration-none"
              to="#features"
              @click="setUrlBack"
              v-scroll-to="'#features'" 
            >Features</router-link>-->
            <b-nav-item
              id="support"
              href="#foot"
              class="my-auto nav-part"
              @click="checkUncheck"
            >
              <b>Support</b>
            </b-nav-item>
            <b-nav-item
              id="login"
              class="my-auto nav-part"
              href="https://www.ftcash.com/app/mdashboard/mLogin"
            >Log In</b-nav-item>
            <!-- <b-nav-item id="login" class="my-auto nav-part" @click="checkUncheck">
              <button
                type="button"
                class="applying-btn btn btn-danger"
                @click="applyLink()"
              >Apply Now</button>
            </b-nav-item> -->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-navbar
        toggleable="lg"
        v-else
        type="dark"
        id="nav-home"
        fixed="top"
        :class="{ change_color: scrollPosition > 50 }"
      >
        <!-- Left aligned Header -->
        <b-navbar-brand href="/" v-if="scrollPosition > 50">
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>
        <b-navbar-brand href="/" v-else>
          <img id="ftcash-logo" :src="require(`@/assets/ftcash-white.png`)" alt="ftcash logo" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" @click="checkUncheck"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned Header -->
          <b-navbar-nav id="dark-nav" class="ml-auto">
            <router-link class="my-auto nav-item nav-part text-decoration-none" to="/">Home</router-link>
            <router-link class="my-auto nav-item nav-part text-decoration-none" to="/about">About us</router-link>
            <b-nav-item-dropdown id="business-loan" class="my-auto nav-part" text="Products" right>
              <router-link to="/secured-business-loan" class="dropdown-item nav-drop-item">Secured</router-link>
              <router-link to="/" class="dropdown-item nav-drop-item">Unsecured</router-link>
              <router-link to="/pos" class="dropdown-item nav-drop-item">PoS</router-link>
            </b-nav-item-dropdown>
            <!--<router-link
              id="nav-features"
              class="my-auto nav-item nav-part text-decoration-none"
              to="#features"
              @click="setUrlBack"
              v-scroll-to="'#features'" 
            >Features</router-link>-->
            <b-nav-item
              id="support"
              href="#foot"
              class="my-auto nav-part"
              @click="checkUncheck"
              
            >
              <b>Support</b>
            </b-nav-item>
            <b-nav-item
              id="login"
              class="my-auto nav-part"
              href="https://www.ftcash.com/app/mdashboard/mLogin"
            >Log In</b-nav-item>
            <!-- <b-nav-item id="login" class="my-auto nav-part" @click="checkUncheck">
              <button
                type="button"
                class="applying-btn btn btn-danger"
                @click="applyLink()"
              >Apply Now</button>
            </b-nav-item> -->
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <div v-else>
      <b-navbar
        toggleable="lg"
        id="nav-new-home"
        v-if="scrollPosition > 50 || clicked === true"
        type="light"
        variant="faded"
        fixed="top"
        :class="{ change_color2: scrollPosition > 50 || clicked === true }"
      >
        <!-- Left aligned Header -->
        <b-navbar-brand href="/" v-if="scrollPosition > 50 || clicked === true">
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>
        <b-navbar-brand href="/" v-else>
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" @click="checkUncheck"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned Header -->
          <b-navbar-nav id="white-nav" class="ml-auto">
            <b-navbar-nav>
              <router-link class="my-auto nav-item nav-part text-decoration-none" to="/">Home</router-link>
              <router-link
                class="my-auto nav-item nav-part text-decoration-none"
                to="/about"
              >About us</router-link>
              <b-nav-item-dropdown
                id="business-loan"
                class="my-auto nav-part"
                text="Products"
                toggle-class="nav-link-custom"
                right
              >
                <template v-slot:button-content>
                  Products
                  <!--<b-icon-caret-down-fill class="float-right mr-2"></b-icon-caret-down-fill>-->
                </template>
                <router-link to="/secured-business-loan" class="dropdown-item nav-drop-item">Secured</router-link>
                <router-link to="/" class="dropdown-item nav-drop-item">Unsecured</router-link>
                <router-link to="/pos" class="dropdown-item nav-drop-item">PoS</router-link>
              </b-nav-item-dropdown>
              <b-nav-item
                id="support"
                href="#foot"
                class="my-auto nav-part"
                 @click="checkUncheck"
              >
                <b>Support</b>
              </b-nav-item>
              <b-nav-item
                id="login"
                class="my-auto nav-part"
                href="https://www.ftcash.com/app/mdashboard/mLogin"
              >Log In</b-nav-item>

              <!-- <b-nav-item id="login" class="my-auto nav-part" @click="checkUncheck">
                <button
                  type="button"
                  class="applying-btn btn btn-danger"
                  @click="applyLink()"
                >Apply Now</button>
              </b-nav-item> -->
              <!--<b-nav-item
                href="https://www.ftcash.com/app/loan/index"
                class=" pr-3"
                ><button type="button" class="btn but btn-danger">
                  Apply Now
                </button></b-nav-item
              >-->
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-navbar
        id="nav-new-home"
        toggleable="lg"
        type="light"
        variant="faded"
        fixed="top"
        :class="{ change_color2: scrollPosition > 50 }"
        v-else
      >
        <!-- Left aligned Header -->
        <b-navbar-brand href="/" v-if="scrollPosition > 50">
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>
        <b-navbar-brand href="/" v-else>
          <img
            id="ftcash-logo"
            class="my-auto"
            :src="require(`@/assets/ftcash-color.png`)"
            alt="ftcash logo"
          />
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" @click="checkUncheck"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned Header -->
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <router-link class="my-auto nav-item nav-part text-decoration-none" to="/">Home</router-link>
              <router-link
                class="my-auto nav-item nav-part text-decoration-none"
                to="/about"
              >About us</router-link>
              <b-nav-item-dropdown
                id="business-loan"
                class="my-auto nav-part"
                text="Products"
                toggle-class="nav-link-custom"
                right
              >
                <template v-slot:button-content>
                  Products
                  <!--<b-icon-caret-down-fill class="float-right mr-2"></b-icon-caret-down-fill>-->
                </template>
                <router-link to="/secured-business-loan" class="dropdown-item nav-drop-item">Secured</router-link>
                <router-link to="/" class="dropdown-item nav-drop-item">Unsecured</router-link>
                <router-link to="/pos" class="dropdown-item nav-drop-item">PoS</router-link>
              </b-nav-item-dropdown>
              <b-nav-item
                id="support"
                href="#foot"
                class="my-auto nav-part"
                 @click="checkUncheck"
              >
                <b>Support</b>
              </b-nav-item>
              <b-nav-item
                id="login"
                class="my-auto nav-part"
                href="https://www.ftcash.com/app/mdashboard/mLogin"
              >Log In</b-nav-item>
              <b-nav-item id="login" class="my-auto nav-part" @click="checkUncheck">
                <!-- <button
                  type="button"
                  class="applying-btn btn btn-danger"
                  @click="applyLink()"
                >Apply Now</button> -->
              </b-nav-item>
              <!--<b-nav-item
                href="https://www.ftcash.com/app/loan/index"
                class=" pr-3"
                ><button type="button" class="btn but btn-danger">
                  Apply Now
                </button></b-nav-item
              >-->
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav-bar",
  props: ["mainPage"],
  data() {
    return {
      scrollPosition: null,
      clicked: false,
      expanded: false,
      className: "",
      type: "",
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    showFooter(){
      this.checkUncheck()
      this.$refs.footerSection.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    },
    checkUncheck() {
      this.clicked = !this.clicked;
    },
    expandUpdate() {
      this.expanded = !this.expanded;
    },
    applyLink() {
      window.open("https://www.ftcash.com/app/loan/index", "_blank");
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);

    document.getElementById("app").addEventListener("scroll", () => {
      var scroll = document.getElementById("app").scrollTop;

      if (scroll > 100) {
        this.scrollPosition = 120;
      } else {
        this.scrollPosition = 0;
         this.clicked = false;
      }
    });
  },
};

</script>

<style>
.router-link-exact-active {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  color: var(--mainlightBlueColor) !important;
}
.collapsing {
  transition: none !important;
}
.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
} /*for the animation*/
.dropdown-toggle:after {
  transition: 0.5s;
}
.nav-drop-item {
  color: var(--mainBlueColor);
}
.change_color {
  background-color: var(--mainWhiteColor);
  color: var(--mainBlueColor);
  box-shadow: 0px 1px 1px rgba(205, 205, 205, 0.6);
}
.change_color2 {
  background-color: var(--mainWhiteColor);
  color: var(--mainBlueColor);
  box-shadow: 0px 1px 1px rgba(205, 205, 205, 0.6);
}
#ftcash-logo {
  float: left;
  width: 8rem;
  margin: 0.6rem 0 0.6rem 1.5rem;
}
#dark-nav > a {
  color: var(--mainWhiteColor);
}
#dark-nav1 > a {
  color: var(--mainBlueColor);
}
#white-nav > a {
  color: var(--mainBlueColor);
}
#white-nav > a:hover,
.navbar-light .navbar-nav .nav-link:hover,
#dark-nav > a:hover {
  color: var(--mainlightBlueColor) !important;
}

.but {
  height: 10%;
}
.navbar-light {
  transition: 100ms ease;
  /* background: var(--mainWhiteColor);
  box-shadow: 0px 1px 1px rgba(205, 205, 205, 0.6); */
}
.navbar-light .navbar-nav .nav-link:focus {
  color: var(--mainBlueColor);
}
.navbar-light .navbar-nav .nav-link {
  color: var(--mainBlueColor);
}
.navbar-light .navbar-nav .nav-part {
  color: var(--mainBlueColor) !important;
}
.navbar-light .navbar-nav .nav-part:hover {
  color: var(--mainlightBlueColor) !important;
}

.navbar-dark {
  transition: 100ms ease;
}
.navbar-dark .navbar-nav .nav-link:focus {
  color: var(--mainWhiteColor);
}
.navbar-dark .navbar-nav .nav-link {
  color: var(--mainWhiteColor);
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: var(--mainlightBlueColor);
}

.navbar-dark1 {
  transition: 500ms ease;
  background: transparent;
  box-shadow: none;
}
.navbar-dark1 .navbar-nav .nav-link:focus {
  color: var(--mainBlueColor);
}
.navbar-dark1 .navbar-nav .nav-link {
  color: var(--mainBlueColor);
}
.navbar-dark1 .navbar-nav .nav-part {
  color: var(--mainBlueColor);
}
.navbar-dark1 .navbar-nav .nav-part:hover {
  color: var(--mainlightBlueColor);
}

.dropdown-toggle::after {
  vertical-align: 0.1em;
}
.navbar {
  padding: 0.25rem 1rem;
  height: 60px;
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active,
.navbar-dark1 .navbar-nav .show > .nav-link,
.navbar-dark1 .navbar-nav .active > .nav-link,
.navbar-dark1 .navbar-nav .nav-link.show,
.navbar-dark1 .navbar-nav .nav-link.active {
  color: var(--mainlightBlueColor);
}

.nav-item {
  padding-top: 0.25rem;
}
.nav-part {
  padding-right: 2rem;
}
.navbar-toggler:focus {
  outline: none;
  border: none;
}
.navbar-toggler {
  border: none;
}
.dropdown-item:hover {
  color: var(--mainlightBlueColor);
}
.dropdown-item {
  text-align: left;
}
.dropdown-toggle {
  outline: none;
}
.dropdown-item.active,
.dropdown-item:active {
  color: var(--mainWhiteColor);
  text-decoration: none;
  background-color: var(--mainBlueColor);
}
.arrow-icon {
  display: none !important;
}
.nav-link:focus {
  color: none;
}
.btn-danger {
  background-color: var(--mainRedColor);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
}
.btn-danger:hover {
  box-shadow: 0px 0px 2px rgba(208, 208, 208, 0.4);
}
/*.navbar-light.navbar-expand-lg{
  background-color:white;
}
/*
.navbar-dark.navbar-expand-lg{
  background-color:white;
}*/

@media (min-width: 1280px) {
  .nav-item {
    padding-top: 0;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .dropdown-item {
    text-align: left;
  }
  .nav-item {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    color: var(--mainBlueColor);
    font-weight: 400;
    padding: 16px 24px;
    border-bottom: 1px solid lightgrey;
  }
  .navbar-collapse {
    padding-top: 0.25rem;
    padding-left: 0;
    padding-right: 0;
  }
  .nav-part {
    padding-right: 0;
    border-bottom: none;
  }
  #ftcash-logo {
    float: left;
    width: 6rem;
    margin: 0.25rem 0 0 10px;
  }
  .nav-link {
    padding: 0;
  }
  .navbar-expand-lg {
    padding-right: 0;
    padding-left: 0;
  }
  .navbar-toggler {
    margin: 0 1rem 0.5rem 0;
  }

  .dropdown-toggle::after {
    float: right;
    margin: 0.7rem 0rem 0 0.5rem;
  }
  .navbar {
    padding-bottom: 0;
    padding-top: 0;
  }
  .dropdown-menu-right {
    border: none;
  }
  .arrow-icon {
    display: block !important;
    float: right;
  }
  #login {
    margin-right: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .dropdown-item {
    text-align: left;
  }
  .nav-item {
    /*text-align: left;
    padding:12px;*/
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    color: var(--mainBlueColor);
    font-weight: 400;
    padding: 16px 24px;
    border-bottom: 1px solid lightgrey;
  }
  .navbar-collapse {
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
  }
  .nav-part {
    padding-right: 0;
  }
  #ftcash-logo {
    float: left;
    width: 6rem;
    margin: 0.25rem 0 0 10px;
  }
  .nav-link {
    padding: 0;
  }
  .navbar-expand-lg {
    padding-right: 0;
    padding-left: 0;
  }
  .navbar-toggler {
    margin: 0 1rem 0.5rem 0;
  }

  .dropdown-toggle::after {
    float: right;
    margin: 0.7rem 2.5rem 0 0;
  }
  .navbar {
    padding-bottom: 0;
    height: auto;
  }
  .dropdown-menu-right {
    border: none;
  }
  .arrow-icon {
    display: block !important;
    float: right;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .dropdown-item {
    text-align: left;
  }
  .nav-item {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    color: var(--mainBlueColor);
    font-weight: 400;
    padding: 16px 24px;
    border-bottom: 1px solid lightgrey;
  }
  .navbar-collapse {
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
  }
  .nav-part {
    padding-right: 0;
  }
  #ftcash-logo {
    float: left;
    width: 6rem;
   margin: 0 0 0 1.5rem;
  }
  .nav-link {
    padding: 0;
  }
  .navbar-expand-lg {
    padding-right: 0;
    padding-left: 0;
  }
  .navbar-toggler {
    margin: 0 1rem 0.5rem 0;
  }

  .dropdown-toggle::after {
    float: right;
    margin: 0.7rem 2.5rem 0 0;
  }
  .navbar {
    padding-bottom: 0;
    height: auto;
  }
  .dropdown-menu-right {
    border: none;
  }
  .arrow-icon {
    display: block !important;
    float: right;
  }
  .navbar-brand {
    padding-top: 0;
  }
}
@media (max-width: 480px) {
  .dropdown-item {
    text-align: left;
  }
  .nav-item {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    color: var(--mainBlueColor);
    font-weight: 400;
    padding: 16px 24px;
    border-bottom: 1px solid lightgrey;
  }
  .navbar-collapse {
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
  }
  .navbar-brand {
    padding-top: 0;
  }
  .nav-part {
    padding-right: 0;
  }
  #ftcash-logo {
    float: left;
    width: 6rem;
    margin: 0 0px 0px 1rem;
  }
  .nav-link {
    padding: 0;
  }
  .navbar-expand-lg {
    padding-right: 0;
    padding-left: 0;
  }
  .dropdown-toggle::after {
    float: right;
    margin: 0.7rem 2.5rem 0 0;
  }
  .navbar {
    padding-bottom: 0;
    height: auto;
  }
  .dropdown-menu-right {
    border: none;
  }
  .arrow-icon {
    display: block !important;
    float: right;
  }
  .navbar-toggler {
    margin: 0 0.2rem 0.5rem 0;
}
}
</style>
